module.exports = __webpack_public_path__ + "static/media/user.4f855749.jpg";